module.exports = __webpack_public_path__ + "img/futuria.boxx.8e4c94b5.webp";